import type { ListTechniciansParams } from '@/shared/types/technicians-table'

export const technicianKeys = {
  all: () => ['technicians'] as const,
  lists: () => [...technicianKeys.all(), 'list'] as const,
  list: (filters?: ListTechniciansParams) =>
    [...technicianKeys.lists(), filters] as const,
  details: () => [...technicianKeys.all(), 'detail'] as const,
  detail: (id: string) => [...technicianKeys.details(), id] as const,
  counts: (id: string) => [...technicianKeys.detail(id), 'counts'] as const,
  filterCounts: () => [...technicianKeys.all(), 'filter-counts'] as const,
  documents: (technicianId: string) =>
    [...technicianKeys.detail(technicianId), 'documents'] as const,
  documentsCount: (technicianId: string) =>
    [...technicianKeys.detail(technicianId), 'documents', 'count'] as const,
  reports: (technicianId: string) =>
    [...technicianKeys.detail(technicianId), 'reports'] as const,
  reportsCount: (technicianId: string) =>
    [...technicianKeys.detail(technicianId), 'reports', 'count'] as const,
}
